<template>
	<transition>
		<div v-show="!atTop && route.name !== 'home'" class="scroll-to-top">
			<button @click="scrollToTop">
				<svg viewBox="0 -960 960 960">
					<path
						d="M180-760v-60h600v60H180Zm270 620v-411.85l-114 114L293.85-480 480-666.15 666.15-480 624-437.85l-114-114V-140h-60Z"
					/>
				</svg>
				<span class="text-label"> Scroll to Top</span>
			</button>
		</div>
	</transition>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { event as gtagEvent } from 'vue-gtag'

const route = useRoute()
const atTop = ref(true)
let pausePositionCheck = false

function checkScrollPosition() {
	if (!pausePositionCheck) {
		atTop.value = window.scrollY <= 0
	}
}

function scrollToTop() {
	pausePositionCheck = true
	atTop.value = true

	window.scrollTo({
		top: 0,
		behavior: window.scrollY < 1024 ? 'smooth' : 'instant',
	})

	gtagEvent('scroll_to_top_click', {})

	setTimeout(() => {
		pausePositionCheck = false
	}, 1000)
}

onMounted(() => {
	window.addEventListener('scroll', checkScrollPosition, {
		passive: true,
	})
})

onUnmounted(() => {
	window.removeEventListener('scroll', checkScrollPosition, {
		passive: true,
	})
})
</script>

<style lang="scss">
@use '@/sass/scroll-to-top.scss';
</style>
